export function initSwipe(handlers) {
  let x0 = 0;

  function lock(event) {
    x0 = unify(event).clientX;
  }

  function move(event) {
    let x1 = unify(event).clientX;
    let dx = x1 - x0;
    let direction = Math.sign(dx);

    if (Math.abs(dx) < 50) return;

    if (direction === -1) handlers.forward();
    else handlers.back();
  }

  return { lock, move };
}

function unify(event) {
  return event.changedTouches ? event.changedTouches[0] : event;
}
